module.exports = __webpack_public_path__ + "img/home-visual-02.f19a2304.png";